/**
 * Auth mode utilities - mirrors Angular's auth-mode.service.ts
 * Cookie "auth_mode=local" indicates internal auth mode
 */

const AUTH_MODE_COOKIE = 'auth_mode';
const INTERNAL_TOKEN_COOKIE = 'internal_access_token';

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

/**
 * Check if app is running in internal auth mode (not Auth0)
 */
export function isInternalAuthMode(): boolean {
  return getCookie(AUTH_MODE_COOKIE) === 'local';
}

/**
 * Get internal access token from cookie (set by Angular app after login)
 */
export function getInternalToken(): string | null {
  return getCookie(INTERNAL_TOKEN_COOKIE);
}

/**
 * Check if user is authenticated in internal mode
 */
export function isInternalAuthenticated(): boolean {
  return isInternalAuthMode() && !!getInternalToken();
}
